<app-modal-wrapper>
  <app-modal-header class="text-center mx-auto">{{this.data.new ? 'Add' : 'Edit'}} Encoder</app-modal-header>
  <app-modal-body>
    <form [formGroup]="form">
      <formly-form [model]="model" [fields]="fields" [form]="form"></formly-form>
    </form>
  </app-modal-body>
  <app-modal-footer class="text-center mx-auto">
    <button class="btn btn-primary" (click)="submit()">Save</button>
  </app-modal-footer>
</app-modal-wrapper>
